import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Editor} from "@tiptap/core";
import { EditorState, Transaction } from 'prosemirror-state'
import TipTapCommentLoader from "./TipTapCommentLoader";
import sugg from "./internal/SuggestionPopup";
import {MentionDTO} from "./internal/MentionDTO";

interface TipTapCommentProps {
    height: number,
}

interface TransactionEvent {
    editor: Editor,
    transaction: Transaction
}

@Dce("TipTapComment")
export default class TipTapComment extends DceComponent<TipTapCommentProps> {

    private editor: Editor;

    private content: HTMLElement;
    private toolbar: HTMLElement;

    private textarea: HTMLInputElement;

    constructor(elem: DceHTMLElement, props: TipTapCommentProps) {
        super(elem, props);

        this.content = document.createElement('div');
        this.content.setAttribute('data-dce-ignore', "");
        this.content.classList.add('tiptap-comment-content');

        this.content.style.minHeight = this.props.height + "px";

        this.elem.append(this.content);

        this.textarea = this.elem.querySelector('textarea, input');

        TipTapCommentLoader.load().then(value => {
            let startContent = "";
            if(this.textarea && this.textarea.value){
                startContent = this.textarea.value;
            }

            this.editor = new value.Editor({
                element: this.content,
                extensions: [
                    ...value.StarterKit,
                    value.Mention.configure({
                        HTMLAttributes: {
                            class: 'mention',
                        },
                        suggestion: sugg(this.loadMentions()),
                        renderLabel: ({ options, node }) => {
                            return `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
                        }
                    })
                ],

                content: startContent,
            });


            if(null != this.textarea){
                this.editor.on('update', () => {
                    this.updateTextarea();
                })
            }

        });
        
    }

    private loadMentions():MentionDTO[]{

        let mentions = this.elem.querySelector("script[data-id='mentions']");
        if(mentions){

            console.log(mentions.innerHTML);

            return JSON.parse(mentions.innerHTML) as MentionDTO[]
        }

        return [];
    }

    private updateTextarea(){
        this.textarea.value = this.editor.getHTML();
    }

    defaultProps(): TipTapCommentProps {
        return {
            height: 48
        }
    }
}
